<template>
	<article>
		<section class="xbed-sub-title">
			<span>发票管理</span>
		</section>

		<section class="xbed-breadcrumb">
			<Breadcrumb>
				<BreadcrumbItem>订单管理</BreadcrumbItem>
				<BreadcrumbItem>发票管理</BreadcrumbItem>
			</Breadcrumb>
		</section>

		<section style="margin-top:20px">
			<Form :model="invoiceForm" inline>
				<FormItem label="创建时间：" prop="createDate" :label-width="84">
					<DatePicker v-model="invoiceForm.createDate" @on-change="dateRange => {changeDate(dateRange, 'createDate')}" :clearable="false" format="yyyy-MM-dd" type="daterange" placeholder="选择日期" style="width: 220px"></DatePicker>
				</FormItem>
				<FormItem label="申请开票方式：" prop="source" :label-width="120">
					<Select v-model="invoiceForm.source" filterable>
						<Option :value="0">全部</Option>
						<Option :value="1">用户申请</Option>
						<Option :value="2">客服开票</Option>
					</Select>
				</FormItem>
				<FormItem prop="orderNo" label="开票订单号：" :label-width="120">
					<Input type="text" v-model="invoiceForm.orderNo"></Input>
				</FormItem>
				<FormItem label="发票来源：" :label-width="120">
					<Select v-model="invoiceForm.sourceType" filterable>
						<Option :value="9">全部</Option>
						<Option :value="0">Xbed</Option>
						<Option :value="1">艺龙</Option>
					</Select>
				</FormItem>
				<FormItem label="发票类型：" prop="invoiceType" :label-width="84">
					<Select v-model="invoiceForm.invoiceType" filterable>
						<Option :value="0">全部</Option>
						<Option :value="1">纸质发票</Option>
						<Option :value="2">电子发票</Option>
					</Select>
				</FormItem>
				<FormItem label="纸质发票状态：" prop="paperState" :label-width="120">
					<Select v-model="invoiceForm.paperState" filterable>
						<Option value="S00">全部</Option>
						<Option :value="0">未开票</Option>
						<Option :value="1">等待寄出</Option>
						<Option :value="2">已寄出</Option>
						<Option :value="4">取消开票</Option>
					</Select>
				</FormItem>
				<FormItem label="电子发票状态：" prop="elecState" :label-width="120">
					<Select v-model="invoiceForm.elecState" filterable>
						<Option value="S00">全部</Option>
						<Option v-for="(state, key) in invoiceElecState" :key="key" :value="key">{{state}}</Option>
					</Select>
				</FormItem>
				<FormItem prop="orderNo" label="发票抬头：" :label-width="84">
					<Input type="text" v-model="invoiceForm.title"></Input>
				</FormItem>
				<FormItem prop="orderNo" label="发票号码：" :label-width="120">
					<Input type="text" v-model="invoiceForm.invoiceNo"></Input>
				</FormItem>
				<FormItem prop="orderNo" label="收票信息：" :label-width="120">
					<Input type="text" v-model="invoiceForm.invoiceInfo"></Input>
				</FormItem>
				<FormItem prop="filter">
					<Button type="primary" @click="queryInvoiceList">查询</Button>
				</FormItem>
				<FormItem prop="download">
					<Button type="primary" @click="exportPaperInvoice" :loading='down.paper'>导出纸质发票</Button>
				</FormItem>
				<FormItem prop="download">
					<Button type="primary" @click="exportEInvoice" :loading='down.elec'>导出电子发票</Button>
				</FormItem>
			</Form>
			<Table stripe :loading="invoiceList.loading" ref="orderReportTable" :columns="column" :data="invoiceList.data"></Table>
			<div style="margin: 10px;overflow: hidden">
				<Page show-sizer placement="top" :total="invoiceList.count" :current="invoiceList.page" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
			</div>
		</section>
		<Modal v-model="invoiceAtRedModal.display" :loading="true" ref="invoiceAtRedModal" title="冲红发票" @on-ok="addInvoiceAtRed" :width="800">
			<Form>
				<FormItem prop="reason" label="冲红原因：" :label-width="80">
					<Input type="textarea" v-model="invoiceAtRedModal.reason"></Input>
				</FormItem>
			</Form>
		</Modal>
		<Modal v-model="resendEmailModal.display" :loading="true" ref="resendEmailModal" title="重发邮件" @on-ok="resendEmail" :width="800">
			<Form>
				<FormItem prop="email" label="邮箱地址：" :label-width="80">
					<Input type="text" v-model="resendEmailModal.email"></Input>
				</FormItem>
			</Form>
		</Modal>
		<Modal v-model="elecStateModal.display" ref="elecStateModal" title="更新状态" @on-ok="updateElecState" :width="800">
			<div>
				<p>确定更新状态吗？</p>
				<p>一经确定无法修改</p>
			</div>
		</Modal>
		<Modal v-model="paperStateModal.display" ref="paperStateModal" :loading="true" title="纸质发票状态" @on-ok="updatePaperState" :width="800">
			<Form :model="paperStateModal" ref="paperStateModalForm" :rules="paperStateModal.rules">
				<FormItem prop="state" label="开票金额：" :label-width="84">
					<p>{{paperStateModal.price | centToDollar}}</p>
				</FormItem>
				<FormItem prop="state" label="发票状态：" :label-width="84">
					<Select v-model="paperStateModal.state" transfer>
						<Option v-if="paperStateModal.currState<=1" :value="1">等待寄出</Option>
						<Option v-if="paperStateModal.currState<=2" :value="2">已寄出</Option>
					</Select>
				</FormItem>
				<template v-if="paperStateModal.state!==0">
					<FormItem prop="vat">
						<RadioGroup v-model="paperStateModal.vat">
							<Radio :label="1">增值税普通发票</Radio>
							<Radio :label="2">增值税专用发票</Radio>
						</RadioGroup>
					</FormItem>
					<FormItem prop="expressCode" label="发票号码：" :label-width="94">
						<Input type="text" v-model="paperStateModal.expressCode"></Input>
					</FormItem>
					<FormItem prop="express" label="快递公司：" :label-width="94">
						<Input type="text" v-model="paperStateModal.express"></Input>
					</FormItem>
					<FormItem prop="expressNo" label="快递单号：" :label-width="94">
						<Input type="text" v-model="paperStateModal.expressNo"></Input>
					</FormItem>
					<FormItem prop="expressFee" label="快递费：￥" :label-width="94">
						<Input type="text" @on-change="checkTypeInNumber" v-model="paperStateModal.expressFee"></Input>
					</FormItem>
				</template>
			</Form>
		</Modal>
		<Modal v-model="addRemarkModal.display" :loading="true" ref="addRemarkModal" title="补充纸质发票备注" @on-ok="addRemark" :width="800">
			<Form :model="addRemarkModal" ref="addRemarkModalForm" :rules="addRemarkModal.rules">
				<FormItem prop="remark" label="备注：" :label-width="80">
					<Input type="textarea" v-model="addRemarkModal.remark" placeholder="请填写备注内容"></Input>
				</FormItem>
			</Form>
		</Modal>
		<Modal v-model="cancelBillingModal.display" :loading="true" ref="cancelBillingModal" title="取消开具纸质发票" @on-ok="cancelBilling" :width="800">
			<Form :model="cancelBillingModal" ref="cancelBillingModalForm" :rules="cancelBillingModal.rules">
				<FormItem prop="remark" label="备注：" :label-width="80">
					<Input type="textarea" v-model="cancelBillingModal.remark" placeholder="请填写取消备注"></Input>
				</FormItem>
			</Form>
		</Modal>

		<Modal v-model="serialNumberModal" title="流水号" :width="600" >
			<span>{{serialNumber}}</span>
			<div slot="footer">
				<Button @click="closeSerialNumberModal">关闭</Button>
			</div>
		</Modal>

		<Modal v-model="invoiceDetailModal" title="更多开票信息" :width="500">
			<Form v-if="invoiceDetail!=null">
                <FormItem  label="房晚数量:" :label-width="120" style="margin-bottom:10px;">
                    <span>{{invoiceDetail.totalRoomNight}}</span>
                </FormItem>
				<FormItem  label="总开票金额:" :label-width="120" style="margin-bottom:10px;">
                    <span>{{(invoiceDetail.price/100).toFixed(2)}}</span>
                </FormItem>
				<FormItem  label="抬头:" :label-width="120" style="margin-bottom:10px;">
                    <span>{{invoiceDetail.title}}</span>
                </FormItem>
				<FormItem  label="收件人:" :label-width="120" style="margin-bottom:10px;" v-if="invoiceDetail.realname">
                    <span>{{invoiceDetail.realname}}</span>
                </FormItem>
				<FormItem  label="联系电话:" :label-width="120" style="margin-bottom:10px;" v-if="invoiceDetail.phone">
                    <span>{{invoiceDetail.phone}}</span>
                </FormItem>
				<FormItem  label="所在省市:" :label-width="120" style="margin-bottom:10px;" v-if="invoiceDetail.provinceName">
                    <span>{{invoiceDetail.provinceName}}{{invoiceDetail.cityName}}{{invoiceDetail.countyName}}</span>
                </FormItem>
				<FormItem  label="详细地址:" :label-width="120" style="margin-bottom:10px;" v-if="invoiceDetail.address">
                    <span>{{invoiceDetail.address}}</span>
                </FormItem>
				<FormItem  label="邮箱:" :label-width="120" style="margin-bottom:10px;" v-if="invoiceDetail.email">
                    <span>{{invoiceDetail.email}}</span>
                </FormItem>
				<FormItem  label="纳税人识别号:" :label-width="120" style="margin-bottom:10px;" v-if="invoiceDetail.taxpayerId">
                    <span>{{invoiceDetail.taxpayerId}}</span>
                </FormItem>
				<FormItem  label="公司地址:" :label-width="120" style="margin-bottom:10px;" v-if="invoiceDetail.entAddress">
                    <span>{{invoiceDetail.entAddress}}</span>
                </FormItem>
				<FormItem  label="公司电话:" :label-width="120" style="margin-bottom:10px;" v-if="invoiceDetail.entContact">
                    <span>{{invoiceDetail.entContact}}</span>
                </FormItem>
				<FormItem  label="公司开户行:" :label-width="120" style="margin-bottom:10px;" v-if="invoiceDetail.entDepositBank">
                    <span>{{invoiceDetail.entDepositBank}}</span>
                </FormItem>
				<FormItem  label="开户行账号:" :label-width="120" style="margin-bottom:10px;" v-if="invoiceDetail.bankAccount">
                    <span>{{invoiceDetail.bankAccount}}</span>
                </FormItem>
				<FormItem  label="发票备注:" :label-width="120" style="margin-bottom:10px;" v-if="invoiceDetail.invoiceRemark">
                    <span>{{invoiceDetail.invoiceRemark}}</span>
                </FormItem>
				<FormItem  label="pdf查看:" :label-width="120" style="margin-bottom:10px;" v-if="invoiceDetail.pdfFile">
						<span><a :href="invoiceDetail.pdfFile" target='_blank' >查看pdf</a></span>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button @click="closeInvoiceDetailModal">关闭</Button>
			</div>
		</Modal>
	</article>
</template>

<script>
import Moment from "moment";
import Utils from "../../utils";
import Config from "../../config";
import API from "../../api";
import {STORE_KEY} from "../../constants";
export default {
	async created() {
		this.token = Utils.findFromLocalStorage( "vue-token" );
		this.username = Utils.findFromLocalStorage( "vue-username" );
		this.env = Utils.findFromLocalStorage( "env", "dev" );
		this.protHeaders = {
      'x-ca-stage': Utils.aliHeaderEnv(this.env), 
      'Authorization': Utils.findFromLocalStorage("Author-token"),
    }
		this.getInvoiceDict();
	},
	async mounted() {
		this.$Notice.config( {
			top: 200
		} );
		this.resetBundle();
		this.queryInvoiceList();
	},
	data() {
		let defaultDate = [
			Moment().subtract( 6, 'days' ).format( 'YYYY-MM-DD' ),
			Moment().format( 'YYYY-MM-DD' )
		];
		const validatepaperState = {
			express: ( rule, value, callback ) => {
				if ( this.paperStateModal.state == 2 && !this.paperStateModal.express ) {
					callback( new Error( '请正确填写快递公司' ) );
				} else {
					callback();
				}
			},
			expressNo: ( rule, value, callback ) => {
				if ( this.paperStateModal.state == 2 && !this.paperStateModal.expressNo ) {
					callback( new Error( '请正确填写快递单号' ) );
				} else {
					callback();
				}
			},
			expressFee: ( rule, value, callback ) => {
				if ( this.paperStateModal.state == 2 && isNaN( parseFloat( this.paperStateModal.expressFee ) ) || parseFloat( this.paperStateModal.expressFee ) < 0 ) {
					callback( new Error( '请正确填写快递费' ) );
				} else {
					callback();
				}
			},
		}

		return {
			invoiceDetailModal: false,
			invoiceDetail: null,
			serialNumberModal: false,
			serialNumber: '',
			down:{
				paper:false,
				elec:false
			},
			invoicePaperState: {
				0: '未开票',
				1: '等待寄出',
				2: '已寄出',
				4: '取消开票'
			},
			invoiceElecState: {
				0: '开票中',
				1: '开票成功',
				2: '已发送邮件',
				3: '开票失败',
				4: '发送邮件失败',
				5: '冲红中',
				6: '已冲红',
				7: '冲红失败',
				10: '红票开票中',
				11: '红票开票成功',
				12: '红票开票失败',
				13: '已重开'
			},
			invoiceDict: {"network": "广州搜床网络科技有限公司"},
			column: [
				{
					title: "申请开票方式",
					key: "source",
					align: "center",
					width: 120,
					render: ( h, params ) => {
						let source = ''
						switch ( params.row.source ) {
							case 1:
								source = "用户申请";
								break;
							case 2:
								source = "客服开票";
								break;
							case 3:
								source = "人工开票";
								break;
						}

						return h( "div", {}, source );
					}
				},
				{
					title: "发票类型",
					align: "center",
					width: 120,
					render: ( h, params ) => {
						let invoiceType = params.row.invoiceType == 1 ? '纸质发票' : '电子发票';
						let invoiceTitle = params.row.invoiceType == 1 ? '' : '查看流水号'
						return h( "div", [
							h("p", {}, invoiceType),
							h("p", {
								style: {
									color: "#2d8cf0"
								},
								on: {
									click: () => {
										this.serialNumberModal = true
										this.serialNumber = params.row.requestCode
									}
								}
							}, invoiceTitle)
						]);
					}
				},
				{
					title: "抬头类型",
					key: "titleType",
					width: 100,
					align: "center",
					render: ( h, params ) => {
						let titleType = params.row.titleType == 1 ? '个人' : '企业';
						return h( "div", {}, titleType );
					}
				},
				{
					title: "发票抬头",
					key: "title",
					width: 150,
					align: "center"
				},
				{
					title: "纳税人识别号",
					key: "taxpayerId",
					width: 200,
					align: "center"
				},
				{
					title: "开票金额",
					key: "price",
					width: 150,
					align: "center",
					render: ( h, params ) => {
						let price = ( params.row.price / 100 ).toFixed( 2 );
						return h( "div", [
							h("p", {}, price),
							h("p", {
								style: {
									color: "#2d8cf0"
								},
								on: {
									click: () => {
										this.invoiceDetailModal = true
										this.invoiceDetail = params.row
									}
								}
							}, '更多开票信息')
						]);
					}
				},
				{
					title: "开票订单",
					key: "orderNo",
					width: 220,
					align: "center",
					render: ( h, params ) => {
						let orderNoArr = ( params.row.orderNo + '' ).split( "," );
						return h( "div", {style: {textAlign: 'left'}}, orderNoArr.map( orderNo => {
							return h( "p", {}, orderNo );
						} ) );
					}
				},
				{
					title: "收票信息",
					key: "address",
					width: 220,
					align: "center",
					render: ( h, params ) => {
						if ( params.row.invoiceType == 2 ) {
							return h( "div", {style: {textAlign: 'left'}}, params.row.email );
						} else if ( params.row.invoiceType == 1 ) {
							let addressText = [
								h( "p", {}, `收件人：${ params.row.realname }` ),
								h( "p", {}, `联系电话：${ params.row.phone }` ),
								h( "p", {}, `收件地址：${ params.row.provinceName }-${ params.row.cityName }-${ params.row.countyName }-${ params.row.address }` )
							]
							return h( "div", {style: {textAlign: 'left'}}, addressText );
						}
					}
				},
				{
					title: "开票主体",
					key: "invoiceConfigKey",
					align: "center",
					width: 200,
					render: ( h, params ) => {
						return h( "div", {}, this.invoiceDict[params.row.invoiceConfigKey] )
					}

				},
				{
					title: "发票状态",
					key: "state",
					width: 100,
					align: "center",
					render: ( h, params ) => {
						let state = '';
						if ( params.row.invoiceType == 1 ) {

							state = this.invoicePaperState[params.row.state];
						} else {

							state = this.invoiceElecState[params.row.state];
						}
						return h( "div", {}, state );
					}
				},
				{
					title: "失败原因",
					key: "resMsg",
					width: 200,
					align: "center"
				},
				{
					title: "发票号码",
					key: "invoiceNo",
					width: 200,
					align: "center"
				},
				{
					title: "快递信息",
					key: "expressInfo",
					width: 200,
					align: "center",
					render: ( h, params ) => {
						let express = params.row.express !== null ? params.row.express : '';
						let expressNo = params.row.expressNo !== null ? params.row.expressNo : '';
						let expressFee = params.row.expressFee !== null ? ( +params.row.expressFee / 100 ).toFixed( 2 ) : '';
						let expressInfo = [
							h( "p", {}, `快递公司：${ express }` ),
							h( "p", {}, `快递单号：${ expressNo }` ),
							h( "p", {}, `快递费：${ expressFee }` )
						];
						return h( "div", {style: {textAlign: 'left'}}, expressInfo );
					}
				},
				{
					title: "创建时间",
					key: "createdAt",
					width: 200,
					align: "center",
					render: ( h, params ) => {
						let createdAt = Moment( params.row.createdAt ).format( 'YYYY-MM-DD HH:mm:ss' );
						return h( "div", {}, createdAt );
					}
				},
				{
					title: "备注",
					key: "remark",
					width: 200,
					align: "center",
					render: ( h, params ) => {
						let remarkStr = params.row.remark || "";
						let remarkArr = remarkStr.split( "\n" );
						return h( "div", remarkArr.map( remark => {
							return h( "p", {}, remark );
						} ) )
					}
				},
				{
					title: "最后修改",
					key: "updatedAt",
					width: 200,
					align: "center",
					render: ( h, params ) => {
						let updatedAt = `${ Moment( params.row.updatedAt ).format( 'YYYY-MM-DD HH:mm:ss' ) } | ${ params.row.updatedName || '' }`;
						return h( "div", {}, updatedAt );
					}
				},
				{
					title: "操作",
					width: 200,
					align: "center",
					render: ( h, params ) => {
						let paperActions = [
							h( "Button", {
								props: {
									type: "warning",
									size: "small"
								},
								style: {
									margin: "5px",
									display: params.row.state == 0 ? 'inline-block' : 'none'
								},
								on: {
									click: () => {
										let actionParams = {
											id: params.row.id,
											remark: ''
										}
										this.openModal( 'cancelBillingModal', actionParams );
									}
								}
							},
								'取消开票' ),
							h( "Button", {
								props: {
									type: "info",
									size: "small"
								},
								style: {
									margin: "5px",
									display: params.row.state == 0 ? 'inline-block' : 'none'
								},
								on: {
									click: () => {
										let actionParams = {
											id: params.row.id,
											remark: ''
										}
										this.openModal( 'addRemarkModal', actionParams );
									}
								}
							},
								'补充备注' ),
							h( "Button", {
								props: {
									type: "primary",
									size: "small"
								},
								style: {
									margin: "5px",
									display: params.row.state == 0 || params.row.state == 1 || params.row.state == 2 ? 'inline-block' : 'none'
								},
								on: {
									click: () => {
										let type = params.row.type ? +params.row.type : 1;
										let expressFee = isNaN( parseFloat( params.row.expressFee ) ) ? 7 : ( params.row.expressFee / 100 );

										let actionParams = {
											id: params.row.id,
											currState: params.row.state,
											state: [1, 2, 2][params.row.state], // 0 -> 1, 1 -> 2, 2 -> 4
											vat: type,
											price: params.row.price,
											express: params.row.express || '',
											expressNo: params.row.expressNo || '',
											expressCode: params.row.invoiceNo || '',
											expressFee: expressFee
										}
										this.openModal( 'paperStateModal', actionParams );
									}
								}
							},
								'发票状态' ),
						]
						let eActions = [
							h( "Button", {
								props: {
									type: "error",
									size: "small"
								},
								style: {
									margin: "5px",
									display: params.row.requestType == 'issue' && (params.row.state == 1 || params.row.state == 2 || params.row.state == 4) ? 'inline-block' : 'none'
								},
								on: {
									click: () => {
										let actionParams = {
											id: params.row.id,
											reason: ''
										}
										this.openModal( 'invoiceAtRedModal', actionParams );
									}
								}
							},
								'发票冲红' ),
							h( "Button", {
								props: {
									type: "info",
									size: "small"
								},
								style: {
									margin: "5px",
									display: params.row.state == 3 ? 'inline-block' : 'none'
								},
								on: {
									click: () => {
										this.signInvoice( params.row );
									}
								}
							},
								'重开发票' ),
							h( "Button", {
								props: {
									type: "info",
									size: "small"
								},
								style: {
									margin: "5px",
									display: params.row.state == 1 || params.row.state == 2 || params.row.state == 4 ? 'inline-block' : 'none'
								},
								on: {
									click: () => {
										let actionParams = {
											id: params.row.id,
											email: params.row.email
										}
										this.openModal( 'resendEmailModal', actionParams );
									}
								}
							},
								'重发邮件' ),

							
							h( "Button", {
								props: {
									type: "primary",
									size: "small"
								},
								style: {
									margin: "5px",
									display: 'none'
									// 需求变更，当电子发票的开票状态未“开票中”时，删除“更新状态"按钮，（新接口不提供手动触发更新状态功能） xzl
									// display: params.row.state == 0 ? 'inline-block' : 'none'
								},
								on: {
									click: () => {
										let actionParams = {
											id: params.row.id
										}
										this.openModal( 'elecStateModal', actionParams );
									}
								}
							},
								'更新状态' ),
						]
						return h( "div", params.row.invoiceType == 1 ? paperActions : params.row.invoiceType == 2 ? eActions : [] );
					}
				}
			],
			invoiceForm: {
				createDate: defaultDate,
				orderNo: '',
				sourceType: 9,
				source: 0,
				invoiceType: 0,
				paperState: "S00",
				elecState: "S00",
				title: "", //发票抬头
				invoiceNo: "", //发票号码
				invoiceInfo: "" //收票信息
			},
			invoiceList: {},
			currModalName: '',
			invoiceAtRedModal: {
				display: false,
				id: '',
				reason: ''
			},
			resendEmailModal: {
				display: false,
				id: '',
				email: ''
			},
			elecStateModal: {
				display: false,
				id: '',
			},
			paperStateModal: {
				display: false,
				loading: false,
				id: '',
				currState: 1,
				state: 1,
				vat: 1,
				price: 0,
				express: '',
				expressNo: '',
				expressFee: 7,
				expressCode: '',
				rules: {
					expressCode: [
						{required: true, type: 'string', message: '请输入发票号码', trigger: 'blur'}
					],
					express: [
						{validator: validatepaperState.express, trigger: 'blur'}
					],
					expressNo: [
						{validator: validatepaperState.expressNo, trigger: 'blur'}
					],
					expressFee: [
						{validator: validatepaperState.expressFee, trigger: 'blur'}
					]
				}
			},
			addRemarkModal: {
				display: false,
				id: '',
				remark: '',
				rules: {
					remark: [
						{required: true, message: '补充备注不能为空', trigger: 'blur'},
						{type: 'string', max: 255, message: '补充备注不能超过255字'}
					]
				}
			},
			cancelBillingModal: {
				display: false,
				id: '',
				remark: '',
				rules: {
					remark: [
						{required: true, message: '取消备注不能为空', trigger: 'blur'},
						{type: 'string', max: 255, message: '取消备注不能超过255字'}
					]
				}
			}
		};
	},
	methods: {
		closeSerialNumberModal() {
			this.serialNumberModal = false
			this.serialNumber = ''
		},
		closeInvoiceDetailModal() {
			console.log('closeInvoiceDetailModal=========')
			this.invoiceDetailModal = false
			this.invoiceDetail = null
		},
		changeDate( dateRange, datePicker ) {
			if ( !dateRange[0] ) {
				this.invoiceForm[datePicker] = [];
			}
		},
		changePage( pageIndex ) {
			this.invoiceList.page = pageIndex;
			this.queryInvoiceList();
		},
		changePageSize( pageSize ) {
			this.invoiceList.page = 1;
			this.invoiceList.pageSize = pageSize;
			this.queryInvoiceList();
		},
		async getInvoiceDict(){
      // 查询发票主体的字典列表
      let params = {
        pageNum: 1,
        pageSize: 10,
        groupId: 47
      }
      const resp = (await API.omsAPI[this.env].clientServer.dictValueList(params, this.protHeaders)).data;
      if(resp.retCode){
        this.$Notice.error({
          title: '获取数据失败',
          desc: resp.msg
        })
        return
      }
			resp.list.map(terminal => {
        let dictName = terminal.dictName
        this.invoiceDict[dictName] = terminal.dictValue
      })
			console.log("this.invoiceDict",this.invoiceDict)
      // this.invoiceDict = resp.list
    },
		async queryInvoiceList() {
			this.invoiceList.loading = true;

			let resp = ( await this.sendQueryInvoiceList( this.invoiceList, this.token, this.env ) ).data;
			if ( resp.retCode ) {
				this.$Notice.error( {
					title: "查询失败",
					desc: resp.msg
				} );
				return;
			}

			this.invoiceList.data = resp.content;
			this.invoiceList.count = resp.totalElements;
			this.invoiceList.loading = false;
		},
		sendQueryInvoiceList( invoiceList, token, env ) {
			let params = {
				startDate: Moment( this.invoiceForm.createDate[0] ).format( 'YYYY-MM-DD' ),
				endDate: Moment( this.invoiceForm.createDate[1] ).format( 'YYYY-MM-DD' ),
				page: invoiceList.page,
				size: invoiceList.pageSize
			};

			this.invoiceForm.orderNo ? params.orderNo = this.invoiceForm.orderNo : '';
			this.invoiceForm.source ? params.source = this.invoiceForm.source : '';
			this.invoiceForm.invoiceType ? params.invoiceType = this.invoiceForm.invoiceType : '';
			this.invoiceForm.paperState !== 'S00' ? params.paperState = this.invoiceForm.paperState : '';
			this.invoiceForm.elecState !== 'S00' ? params.elecState = this.invoiceForm.elecState : '';
			this.invoiceForm.title && ( params.title = this.invoiceForm.title );
			this.invoiceForm.invoiceNo && ( params.invoiceNo = this.invoiceForm.invoiceNo );
			this.invoiceForm.invoiceInfo && ( params.invoiceInfo = this.invoiceForm.invoiceInfo );
			params.sourceType = this.invoiceForm.sourceType == 9 ? "" : this.invoiceForm.sourceType;


			return API.omsAPI[env].order.queryInvoiceList(
				params,
				token
			);
		},
		exportPaperInvoice() {
			if ( !this.checkHasPermission( 'excel_invoice' ) ) {
				return;
			}

			let url = `${ Config[this.env].analysisUrl }excel/invoice` +
				"?startDate=" + Moment( this.invoiceForm.createDate[0] ).format( 'YYYY-MM-DD' ) +
				"&endDate=" + Moment( this.invoiceForm.createDate[1] ).format( 'YYYY-MM-DD' )

			// window.open( url, "_blank" );			
			Utils.exportExcelWeighting(url,this.token,this.$Notice.error,this.down,'paper')
		}, 
		exportEInvoice() {
			if ( !this.checkHasPermission( 'excel_elecInvoice' ) ) {
				return;
			}

			let url = `${ Config[this.env].analysisUrl }excel/elecInvoice` +
				"?startDate=" + Moment( this.invoiceForm.createDate[0] ).format( 'YYYY-MM-DD' ) +
				"&endDate=" + Moment( this.invoiceForm.createDate[1] ).format( 'YYYY-MM-DD' )

			// window.open( url, "_blank" );
			Utils.exportExcelWeighting(url,this.token,this.$Notice.error,this.down,'elec')

		},
		openModal( currModalName, params ) {
			this.currModalName = currModalName;
			this[currModalName] = Object.assign( {}, this[currModalName], params );
			this[this.currModalName].display = true;
		},
		closeModal() {
			this[this.currModalName].display = false;
		},
		async signInvoice( params ) {
			let actionParams = {
				sourceType: params.sourceType,
				invoiceMoney: ( params.price / 100 ).toFixed( 2 ),
				realMoney: ( params.price / 100 ).toFixed( 2 ),
				orderNo: params.orderNo,
				applyPhone: params.phone,
				remark: params.remark,
				cityName: params.cityName,
				countyName: params.countyName,
				phone: params.phone,
				realname: params.realname,
				provinceName: params.provinceName,
				invoiceType:  params.invoiceType,
				titleType: params.titleType,
				title: params.title,
				taxpayerId: params.taxpayerId,
				email: params.email,
				price: params.price,
				orderPrice: params.price,
				totalRoomNight: params.totalRoomNight,
				invoiceRemark: params.invoiceRemark,
				account: this.username,
				reopenId: params.id,
			}
			console.log("signInv", actionParams);
			let resp = ( await API.omsAPI[this.env].php.signInvoice( actionParams ) ).data
			if ( resp.retCode === 21020000 ) {
				this.$Notice.success( {title: "操作成功！"} );
				this.invoiceList.loading = true
				setTimeout(()=>this.queryInvoiceList(),2000)
			} else {
				this.$Notice.error( {title: resp.msg || resp.retmsg} );
			}
		},
		async addInvoiceAtRed() {
			if ( this.invoiceAtRedModal.reason.length == 0 ) {
				this.$Notice.error( {
					title: "请填写冲红原因"
				} );
				return;
			}

			let resp = ( await API.omsAPI[this.env].order.revokeElectronicInvoice(
				this.invoiceAtRedModal.id,
				this.username,
				this.invoiceAtRedModal.reason,
				this.token
			) ).data;

			if ( resp.retCode ) {
				// 错误警告
				this.showNotice( 'error', '发票冲红失败', resp.msg )

				this.$refs.invoiceAtRedModal.buttonLoading = false;

			} else {

				this.showNotice( 'success', '发票冲红成功' )

				this.invoiceAtRedModal.display = false;
				this.refreshTable()
			}
		},
		async resendEmail() {
			let matchEmailResult = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test( this.resendEmailModal.email );
			if ( !matchEmailResult ) {
				this.$Notice.error( {
					title: "电子邮箱格式不正确"
				} );
				return;
			}

			let resp = ( await API.omsAPI[this.env].order.resendElecInvoiceByEmail(
				this.resendEmailModal.id,
				this.resendEmailModal.email,
				this.token
			) ).data;

			if ( resp.retCode ) {
				// 错误警告
				this.showNotice( 'error', '重发邮件失败', resp.msg )

				this.$refs.resendEmailModal.buttonLoading = false;

			} else {

				this.showNotice( 'success', '重发邮件成功' )

				this.resendEmailModal.display = false;
				this.refreshTable()
			}
		},
		async updateElecState() {

			let resp = ( await API.omsAPI[this.env].order.updateElecInvoiceState(
				this.elecStateModal.id,
				this.token
			) ).data;

			if ( resp.retCode ) {
				// 错误警告
				this.showNotice( 'error', '更新状态失败', resp.msg )

			} else {

				this.showNotice( 'success', '更新状态成功' )

				this.elecStateModal.display = false;
				this.refreshTable()
			}
		},
		async updatePaperState() {
			let validResult = true;
			this.$refs.paperStateModalForm.validate( ( valid ) => {
				if ( !valid ) {
					validResult = valid;
				}
			} )
			if ( !validResult ) {

				this.$refs.paperStateModal.buttonLoading = false;
				return;
			}
			isNaN( this.paperStateModal.expressFee )

			let params = {
				id: this.paperStateModal.id,
				express: this.paperStateModal.express,
				expressFee: !isNaN( this.paperStateModal.expressFee ) ? Number.parseFloat( this.paperStateModal.expressFee ) * 100 : '',
				expressNo: this.paperStateModal.expressNo,
				stat: this.paperStateModal.state,
				invoiceNo: this.paperStateModal.expressCode,
				type: this.paperStateModal.vat
			};

			params = Utils.deleteEmptyProperty( params );

			let resp = ( await API.omsAPI[this.env].order.updateInvoiceExpress(
				params,
				this.token
			) ).data;

			if ( resp.retCode ) {
				// 错误警告
				this.showNotice( 'error', '更新状态失败', resp.msg )

				this.$refs.paperStateModal.buttonLoading = false;

			} else {

				this.showNotice( 'success', '更新状态成功' )

				this.paperStateModal.display = false;
				this.refreshTable()
			}
		},
		async addRemark() {
			let validResult = true;
			this.$refs.addRemarkModalForm.validate( ( valid ) => {
				if ( !valid ) {
					validResult = valid;
					this.$refs.addRemarkModal.buttonLoading = false;
				}
			} )

			if ( !validResult ) {
				return;
			}

			let resp = ( await API.omsAPI[this.env].order.appendInvoiceRemark(
				this.addRemarkModal.id,
				this.username,
				this.addRemarkModal.remark,
				this.token
			) ).data;

			if ( resp.retCode ) {
				// 错误警告
				this.showNotice( 'error', '补充备注失败', resp.msg )

				this.$refs.addRemarkModal.buttonLoading = false;

			} else {

				this.showNotice( 'success', '补充备注成功' )

				this.addRemarkModal.display = false;
				this.refreshTable()
			}
		},
		async cancelBilling() {
			let validResult = true;
			this.$refs.cancelBillingModalForm.validate( ( valid ) => {
				if ( !valid ) {
					validResult = valid;
					this.$refs.cancelBillingModal.buttonLoading = false;
				}
			} )

			if ( !validResult ) {
				return;
			}

			let resp = ( await API.omsAPI[this.env].order.cancelInvoice(
				this.cancelBillingModal.id,
				this.username,
				this.cancelBillingModal.remark,
				this.token
			) ).data;

			if ( resp.retCode ) {
				// 错误警告
				this.showNotice( 'error', '取消发票失败', resp.msg )

				this.$refs.cancelBillingModal.buttonLoading = false;

			} else {

				this.showNotice( 'success', '取消发票成功' )

				this.cancelBillingModal.display = false;
				this.refreshTable()
			}
		},
		showNotice( status = 'error', title = '', desc = '' ) {
			this.$Notice[status]( {
				title,
				desc
			} );
		},
		checkTypeInNumber( event ) {
			let expressFee = event.target.value.replace( /[^(\d|\.)]/g, '' );

			this.$nextTick( () => {
				this.paperStateModal.expressFee = expressFee;
			} )

		},
		checkHasPermission( name ) {
			if ( !Utils.hasPermission( name ) ) {
				this.$Notice.error( {
					title: Utils.getFromStore( STORE_KEY.STORE_KEY_NOT_PERMISSION_TIPS )
				} );

				return false;
			}
			return true;
		},
		resetBundle() {
			this.invoiceList = {
				count: 0,
				pageCount: 0,
				page: 1,
				pageSize: 10,
				loading: false,
				data: []
			};
		},
		refreshTable() {
			this.resetBundle();
			this.queryInvoiceList();
		}
	},
	filters: {
		centToDollar: function ( price ) {
			if ( !price ) return 0
			return Number.parseFloat( price / 100 ).toFixed( 2 );
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/pages/order/invoice.vue